/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$(document).on('click','.bundle-outer .popup-trigger',function(){
   $('body').addClass('popup-active');
})
$(document).mouseup(function(e) 
    {
      
    var container = $(".custom-quick-view-popup .popup-container");
    var container2 = $('.pdp-size-modal .Modal__inner-sct');
    var arrows = $('.quickview-arrows svg');
      if (!container.is(e.target) && container.has(e.target).length === 0  && !arrows.is(e.target) && $('.custom-quick-view-popup').hasClass('is-visible')) 
      {
      $('.custom-quick-view-popup').removeClass('is-visible')
      $('body').removeClass("popup-active");
      }
      if ($('.modal_popup-overlay').is(e.target)) {
       $('.pdp-size-modal').attr('aria-hidden',true);
       $('body').removeClass("popup-active");
      }
    }); 
$('.Product__Info .stamped-main-badge').click(function(){
    $('html, body').animate({
        scrollTop: $(".productMeta_reviews").offset().top -  $('.Header__Wrapper').outerHeight()
    }, 1000);
});
$('.open-size-chart').click(function(e){
   $('body').addClass("popup-active");
  $('#modal-sizing-charts-all').attr('aria-hidden',false);
    e.preventDefault();
    $.ajax({
     type:"get",   
     url:$(this).attr('href'), 
     success:function(data){
     $('#modal-sizing-charts-all .Container').html($('#shopify-section-template--23831052943747__pf-e70f8bc4',data).html()); 
        
     }   
    })
});
$('.pdp-size-modal .Modal__Close').click(function(){
    $('#modal-sizing-charts-all').attr('aria-hidden',true);
    $('body').removeClass("popup-active");
});
$(".main-tabs-headings h3.shopify_explorer_tab__header").click(function(){
  $(".main-tabs-headings h3.shopify_explorer_tab__header").removeClass("is__active");
  $(this).addClass("is__active");
  var handle=$(this).attr("data-handle").trim();
  $(".Container.events_section .main_image_with-text-section").each(function(){
    var Each_handle=$(this).attr("data-handle").trim();
    if(Each_handle.includes("~~")){
      var numbersArray = Each_handle.split('~~');
      var all=' ';
      var count = 0;
      $.each(numbersArray, function(index, value) { 
        var new_value= value.replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        if( new_value == handle ){
          all += new_value; 
          count++;
        }
      });
      if( count == 0 ){
        $(this).hide();
      }
      else{
        $(this).show();
      }
    }
    else if( Each_handle == handle){
      $(this).show();
    }
    else{
      $(this).hide();
    }
  });
  if($(".Container.events_section .main_image_with-text-section:visible").length == 0){
    $(".Container.events_section .not-match-error-massage").addClass("No_showed");
  }
  else{
    $(".Container.events_section .not-match-error-massage").removeClass("No_showed");
  }

});


$(document).ready(function() {
   $("#checkout").addClass("disabled");
    $('#agree').change(function() {
    var state = $(this).is(':checked'); 
       $(".checkbox-add").find(".error-message").remove();
    if (state) { 
        $('#checkout').removeClass('disabled');
     $(".checkbox-add").find(".error-message").remove();
    } else { 
        $('#checkout').addClass('disabled');
        $(".checkbox-add").append("<span class='error-message '><small>Please accept terms & conditions</small></span>");
      
    }
});


  
    // Configure/customize these variables.
    var showChar = 100;  // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = "Read more...";
    var lesstext = "Read less...";
    

    $('.more').each(function() {
        var content = $(this).html();
 
        if(content.length > showChar) {
 
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);
 
            var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';
 
            $(this).html(html);
        }
 
    });
 
    $(".morelink").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }
        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;
    });
  $(".Container.events_section .tab_nt .main-tabs-headings h3.shopify_explorer_tab__header").eq(0).trigger("click");
});




 $('.gallary-image-block').slick({
    slidesToShow: 3,
    dots: false,
     prevArrow:"<button type='button' class='limages-with-video-gallery slick-prev'><svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.002 512.002' style='enable-background:new 0 0 512.002 512.002;' xml:space='preserve'><g><g><path d='M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105    L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795    l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z'/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>",
    nextArrow:"<button type='button' class='images-with-video-gallery slick-next'><svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.002 512.002' style='enable-background:new 0 0 512.002 512.002;' xml:space='preserve'><g><g><path d='M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105    L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795    l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z'/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>",
    swipe: true,
    infinite: true,
    swipeToSlide: true,
    adaptiveHeight: true,
    centerMode: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 641,
      settings: {
        slidesToShow: 1
      }
    }
  ]
  });


  function addtocart(item){
    var thisitem = $(item);
    var productid = thisitem.attr('data-id');
    console.log(productid);
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data:{
        id: productid,
      },
      dataType: 'json',
      
      success: function(productid){
            console.log(productid);
         if($(window).width() <768){
           $('.ProductMeta__bundle .custom-quick-view-popup.is-visible').removeClass('is-visible');
         }
updateDrawer();
        jQuery.ajax({
          type: 'GET',
          url: '/cart',
          dataType: 'html',
          success: function(cart){      
//             $('#sidebar-cart').html($(cart).find('#sidebar-cart').html());
            $('.Header__CartCount').html($(cart).find('.Header__CartCount').html());
            
          },

        });

      },

    });
  }

function updateDrawer() {
    const rerenderCart = () => {
        let cartDot = [].slice.call(document.querySelectorAll('.Header__CartDot')),
            cartQuantity = [].slice.call(document.querySelectorAll('.Header__CartCount'));

        cartDot.forEach((item) => {
            if (this.itemCount === 0) {
                item.classList.remove('is-visible'); // IE 11 and lower does not support second attribute of toggle :(
            } else {
                item.classList.add('is-visible');
            }
        });

        cartQuantity.forEach((item) => {
            //item.textContent = this.itemCount;
          if ($("body").hasClass("custom_coll"))
           {
             item.textContent = this.itemCount;
            
           }
          else
          {
              jQuery.getJSON('/cart.js', function(cart) {
            var item=cart.item_count;
            $('body.template-product .Header__CartCount').html(item);
          }); 
          }
        });

        // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
        return fetch('/cart?view=' + (this.options['drawer'] ? 'drawer' : 'ajax') + '&timestamp=' + Date.now(), {
            credentials: 'same-origin',
            method: 'GET'
        }).then((content) => {
            content.text().then((html) => {
                replaceContent(html);
            });
        });
    }

    const replaceContent = (html) => {
        let tempElement = document.createElement('div');
        tempElement.innerHTML = html;

        // Convert in background
        // if (window.theme.currencyConversionEnabled) {
        //   __WEBPACK_IMPORTED_MODULE_2__helper_Currency__["default"].convertAll(tempElement);
        // }

        let cartNodeParent = this.element.querySelector('.Cart').parentNode;

        if (this.options['drawer']) {
          let currentScrollPosition = this.element.querySelector('.Drawer__Main').scrollTop;
          cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
          this.element.querySelector('.Drawer__Main').scrollTop = currentScrollPosition;
        } else {
          // For dedicated page we replace the whole section if there is no more product
          if (this.itemCount === 0) {
            this.element.innerHTML = tempElement.querySelector('.shopify-section').firstElementChild.innerHTML;
          } else {
            cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
            this.element.querySelector('.PageHeader').innerHTML = tempElement.querySelector('.PageHeader').innerHTML;
          }
        }
    }

    this.element = document.getElementById('sidebar-cart');
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

    this.itemCount = parseInt(
        [].slice.call(document.querySelectorAll('.QuantitySelector__CurrentQuantity'))
            .map(x => parseInt(x.value))
            .reduce((a, b) => a + b, 0)
    ) + 1;

    this.drawer = new Drawer(this.element)

    rerenderCart().then(() => {
        this.drawer.open()
        this.element.dataset.sectionSettings = JSON.stringify(this.options)
    });
/*console.log('track');
snaptr('track', 'START_CHECKOUT');*/
}

const Drawer = function () {
    function Drawer(element) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Drawer);

        this.element = element;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.delegateBody = new domDelegate.Delegate(document.body);

        this.onOpen = options['onOpen'] || function () {};
        this.onClose = options['onClose'] || function () {};

        this.isOpen = false;
        this.direction = this.element.classList.contains('Drawer--fromLeft') ? 'fromLeft' : 'fromRight';

        this.pageOverlayElement = document.querySelector('.PageOverlay');

        this._attachListeners();
    }

    _createClass(Drawer, [{
        key: 'destroy',
        value: function destroy() {
            this.delegateBody.off('click', '[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]');
            this.delegateBody.off('click', '[data-action="close-drawer"][data-drawer-id="' + this.element.id + '"]');
            window.removeEventListener('resize', this._calculateMaxHeightListener);
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            this.isOpen ? this.close() : this.open();
        }
    }, {
        key: 'open',
        value: function open(event) {
            if (this.isOpen) {
                return;
            }

            if (event) {
                event.preventDefault();
            }

            this.element.setAttribute('aria-hidden', 'false');
            this._calculateMaxHeight();

            document.documentElement.classList.add('no-scroll');

            // This prevent the body to scroll on iOS. This is honestly a bit hacky, but until the platform supports "touch-action: none" like
            // other browsers, this is the only way to achieve that
            disableBodyScroll(true, '[data-scrollable]');

            // We attach an event to the page overlay to close it
            this.pageOverlayElement.classList.add('is-visible');
            this.pageOverlayElement.addEventListener('click', this._closeListener);

            this.isOpen = true;

            this.onOpen(); // Call the callback to allow other code to hook their logic

            return false;
        }
    }, {
        key: 'close',
        value: function close(event) {
            if (!this.isOpen) {
                return;
            }

            if (event) {
                event.preventDefault();
            }

            this.element.setAttribute('aria-hidden', 'true');

            document.documentElement.classList.remove('no-scroll');

            disableBodyScroll(false, '[data-scrollable]');

            this.pageOverlayElement.classList.remove('is-visible');
            this.pageOverlayElement.removeEventListener('click', this._closeListener);

            this.isOpen = false;

            this.onClose(); // Call the callback to allow other code to hook their logic
        }
    }, {
        key: '_attachListeners',
        value: function _attachListeners() {
            this._openListener = this.open.bind(this);
            this._closeListener = this.close.bind(this);
            this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);

            this.delegateBody.on('click', '[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]', this._openListener);
            this.delegateBody.on('click', '[data-action="close-drawer"][data-drawer-id="' + this.element.id + '"]', this._closeListener);
            this.element.addEventListener('keyup', this._handleKeyboard.bind(this));
            window.addEventListener('resize', this._calculateMaxHeightListener);
        }

        /**
         * Make sure that we force a max-height so that the drawer always stays on screen
         */

    }, {
        key: '_calculateMaxHeight',
        value: function _calculateMaxHeight() {
            this.element.style.maxHeight = window.innerHeight + 'px';
        }
    }, {
        key: '_handleKeyboard',


        /**
         * Handle a11y events
         */
        value: function _handleKeyboard(event) {
            if (this.isOpen && event.keyCode === 27) {
                this.close();
            }
        }
    }]);

    return Drawer;
}();


  jQuery(document).ready(function($){
  //open popup
  $('.popup-trigger').on('click', function(event){
    event.preventDefault();
var popup_link = $(this).attr("href");
console.log(popup_link);
$("."+popup_link).addClass('is-visible');
    
        $('.product-quickview-slick-slider-lilie-page').slick('setPosition');
    $('.product-quickview-slick-slider').slick('setPosition');
        });
    
      $('.popup-close').on('click', function(event){
    event.preventDefault();
$(".custom-quick-view-popup").removeClass('is-visible');
  $('body').removeClass("popup-active");
        });
    $('.product-quickview-slick-slider').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1, 
      prevArrow:"<button type='button' class='quickview-arrows slick-prev'><svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.002 512.002' style='enable-background:new 0 0 512.002 512.002;' xml:space='preserve'><g><g><path d='M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105    L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795    l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z'/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>",
      nextArrow:"<button type='button' class='quickview-arrows slick-next'><svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.002 512.002' style='enable-background:new 0 0 512.002 512.002;' xml:space='preserve'><g><g><path d='M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105    L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795    l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z'/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>",
      dots: false,
      adaptiveHeight: true
    });
    

});



    $('select.product-quickview-selected-value').on('change', function (e) {
  
      var text ='';
        $(this).parents("form").find(".product-quickview-selected-value").each(function(){
         
         
            text += $(this).val()+" / ";
         
        });
        var newname = text.slice(0,-2);

      console.log(newname);
var data_select = $.trim(newname);
       var variantt = $(this).parents("form").find("select.diffrent-hidden-select option[data-value='"+data_select+"']").attr("data-id");
      console.log(variantt);
     $(".quick-view-add-to-cart-button.button").attr("data-id", variantt);
});
 
// !function(s){s.fn.moreLines=function(e){"use strict";return this.each(function(){var t=s(this),i=(t.find("p"),parseFloat(t.css("line-height"))),a=t.innerHeight(),n=s.extend({linecount:1,baseclass:"b-morelines_",basejsclass:"js-morelines_",classspecific:"section",buttontxtmore:"more lines",buttontxtless:"less lines",animationspeed:1},e),c=n.baseclass+n.classspecific+"_ellipsis",l=n.baseclass+n.classspecific+"_button",o=n.baseclass+n.classspecific+"_wrapper",h=n.basejsclass+n.classspecific+"_wrapper",r=s("<div>").addClass(o+" "+h).css({"max-width":t.css("width")}),m=i*n.linecount;if(t.wrap(r),t.parent().not(h)&&a>m){t.addClass(c).css({"min-height":m,"max-height":m,overflow:"hidden"});var p=s("<div>",{class:l,click:function(){t.toggleClass(c),s(this).toggleClass(l+"_active"),"none"!==t.css("max-height")?t.css({height:m,"max-height":""}).animate({height:a},n.animationspeed,function(){p.html(n.buttontxtless)}):t.animate({height:m},n.animationspeed,function(){p.html(n.buttontxtmore),t.css("max-height",m)})},html:n.buttontxtmore});t.after(p)}}),this}}(jQuery);

// $(function() {
  
//   $('.custom-quick-view-popup .popup-container .product-right-part-images .ProductMeta__Description.Rte').moreLines({
//     linecount: 4, 
//     baseclass: 'b-description',
//     basejsclass: 'js-description',
//     classspecific: '_readmore',    
//     buttontxtmore: "Read More",               
//     buttontxtless: "Read Less",
//     animationspeed: 500 
    
//   });
  
// });

$('body').on('click', '.Product__Wrapper .Product__InfoWrapper .description', function() {
    $(this).next('.Product__Wrapper .Product__InfoWrapper .ProductMeta__Description.Rte').slideToggle(150).toggleClass('active');
    $(this).toggleClass('active');
  });

$('body').on('click', '.Product__Wrapper .Product__InfoWrapper .additional-information', function() {
    $(this).next('.Product__Wrapper .Product__InfoWrapper .productMeta_additional-information, .ProductMeta__bundle').slideToggle(150).toggleClass('active');
  //$('.ProductMeta__bundle',this).slideToggle(150).toggleClass('active');
    $(this).toggleClass('active');
  });
$('body').on('click', '.Product__Wrapper .Product__InfoWrapper .review-information', function() {
    $(this).next('.Product__Wrapper .Product__InfoWrapper .productMeta_reviews').slideToggle(150).toggleClass('active');
    $(this).toggleClass('active');
  });



$('.main-row-collection.lillie-collection-slider').slick({
    slidesToShow: 4,
    dots: false,
     prevArrow:"<button type='button' class='lillie-collection-slider slick-prev'><svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.002 512.002' style='enable-background:new 0 0 512.002 512.002;' xml:space='preserve'><g><g><path d='M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105    L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795    l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z'/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>",
    nextArrow:"<button type='button' class='lillie-collection-slider slick-next'><svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.002 512.002' style='enable-background:new 0 0 512.002 512.002;' xml:space='preserve'><g><g><path d='M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105    L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795    l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z'/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>",
    swipe: true,
    infinite: false,
    swipeToSlide: true,
    adaptiveHeight: true,
    centerMode: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 641,
      settings: {
        slidesToShow: 1
      }
    }
  ]
  });
     $('.product-quickview-slick-slider-lilie-page').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1, 
      prevArrow:"<button type='button' class='quickview-arrows slick-prev'><svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.002 512.002' style='enable-background:new 0 0 512.002 512.002;' xml:space='preserve'><g><g><path d='M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105    L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795    l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z'/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>",
      nextArrow:"<button type='button' class='quickview-arrows slick-next'><svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.002 512.002' style='enable-background:new 0 0 512.002 512.002;' xml:space='preserve'><g><g><path d='M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105    L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795    l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z'/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>",
      dots: false,
      adaptiveHeight: true
    });
  


function Main_slider_arrows(){
  if($(window).width() <= 992){
    var image_Height = $(".shopify-section--slideshow--text .main.image-wrapper.slick-active .slier_ntimage img").height();
    var finalHeight =image_Height /2;
    $(".main-image-with-text .Sider-section-homepage.slick-arrow").css("top",finalHeight+'px');
  }}
$(document).ready(function(){
  Main_slider_arrows();
  $(".main-image-with-text .slick-carousel").on("afterChange", function (){
    Main_slider_arrows();
  })
  $(window).resize(function(){
    Main_slider_arrows();
  });
});



$(document).mouseup(function (e) {
if ($(e.target).closest("#Search").length
=== 0) {
$(".desktop_search_bar_header").removeClass("search-active");
}
});
$("a.desktop_search").click(function(e){
e.preventDefault();
$(".desktop_search_bar_header").addClass("search-active");

});
$(".desktop_search_bar_header button.Search__Close.Link.Link--primary").click(function(){
$(".desktop_search_bar_header").removeClass("search-active");
});



$("a.mobile_search").click(function(e){
e.preventDefault();
$(".mobile_search_bar_header").addClass("search-active");

});
$(".mobile_search_bar_header button.Search__Close.Link.Link--primary").click(function(){
$(".mobile_search_bar_header").removeClass("search-active");

});
$(document).mouseup(function (e) {
if ($(e.target).closest("#Search").length
=== 0) {
$(".mobile_search_bar_header").removeClass("search-active");
}
});


$(".Search__Form input.Search__Input.Heading").keyup(function() {
var value = $(this).val();
if ( value.length > 0){
$(".Search__Results").addClass("showed");
} 
else{
$(".Search__Results").removeClass("showed");
}

});